export default __webpack_public_path__ + "static/media/cdsadminmgr.0e556003.svg";